import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Kernal from './Kernal';

console.info(`
  << 🥏 >>

 ⊂  .@.  ⊃
  \\ (°° /
   \\|T|/
    |=|
    / \\
  _/   \\_

     ~ Hi I'm Tron
       and I fight for the users! ~
`);

ReactDOM.render(<Kernal />, document.getElementById('root'));
